


function stickyHeader() {
  if (document.querySelector(".header")) {
    let header = document.querySelector("header");
    let sticky = 980;

    function handleScroll() {
      if (window.scrollY > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }

    window.addEventListener("scroll", handleScroll);
    // Call once on load
    handleScroll();
  }
}

export default stickyHeader;
